/**
 * @author        quanquan
 * @dateTime      2020-07-30 09:37:16
 * @description
 */

import PigeonJs from './pigeon'

global.PigeonJs = PigeonJs

export * from '@vue/utils'

export * from '@fedor/utils'

export * from './verification'

export * from './IPAddress'

export * from './format'

const lineToHump = n => n.replace(/\_(\w)/g, (all, letter) => { // eslint-disable-line
  return letter.toUpperCase()
})

const isDivisible = (dividend, divisor) => dividend % divisor === 0

export const addCSS = (cssText) => {
  let style = document.createElement('style') // 创建一个style元素
  let head = document.head || document.getElementsByTagName('head')[0] // 获取head元素
  style.type = 'text/css' // 这里必须显示设置style元素的type属性为text/css，否则在ie中不起作用
  if (style.styleSheet) { // IE
    let func = function () {
      try { // 防止IE中stylesheet数量超过限制而发生错误
        style.styleSheet.cssText = cssText
      } catch (e) {

      }
    }
    // 如果当前styleSheet还不能用，则放到异步中则行
    if (style.styleSheet.disabled) {
      setTimeout(func, 10)
    } else {
      func()
    }
  } else { // w3c
    // w3c浏览器中只要创建文本节点插入到style元素中就行了
    let textNode = document.createTextNode(cssText)
    style.appendChild(textNode)
  }
  head.appendChild(style) // 把创建的style元素插入到head中
}

export const handleGetBlob = url => {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.crossOrigin = '*'
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response)
      }
    }
    xhr.send()
  })
}

export const handleSaveAs = (
  blob, filename
) => {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    const body = document.querySelector('body')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    // fix Firefox
    link.style.display = 'none'
    body.appendChild(link)
    link.click()
    body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }
}

export {
  PigeonJs,
  lineToHump,
  isDivisible
}



// WEBPACK FOOTER //
// ./src/js/module/utils/index.js